import { Stack } from '@mui/material';
import { FlowFieldDataTypesWithoutList, FlowSortDirection } from 'flow-schema';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField.tsx';

export function SortBlockFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.sortConfig.fieldToSort"
        label="Field to sort"
        helperText="The name of a field in each entry in the list to sort by (can be dynamically specified via {{...}} notation); leave blank to remove sorting"
      />
      <BlockSelectField
        fieldName="config.sortConfig.dataType"
        label="Data type"
        options={Object.values(FlowFieldDataTypesWithoutList).map((entry) => ({
          label: entry,
          value: entry,
        }))}
      />
      <BlockSelectField
        fieldName="config.sortConfig.sortDirection"
        label="Sort direction"
        options={Object.values(FlowSortDirection).map((entry) => ({
          label: entry,
          value: entry,
        }))}
      />
    </Stack>
  );
}
